var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React, { Component } from 'react';
import { AwesomeComponent, ComponentType } from '@philips-internal/oswald-ui-core';
import { bool } from '@philips-internal/oswald-ui-core/lib/component/prop-types/index.js';
import TimerAPI from './timer-api';
let Timer = class Timer extends Component {
    constructor() {
        super(...arguments);
        this.intervalId = null;
        this.state = {
            isRunning: false,
            seconds: 0,
            time: '00:00',
        };
        this.updateTimer = () => {
            this.setState((prevState) => {
                const newSeconds = prevState.seconds + 1;
                return {
                    seconds: newSeconds,
                    time: this.formatTime(newSeconds),
                };
            });
        };
    }
    static { this.propTypes = {
        isRunning: bool,
    }; }
    componentDidUpdate(prevProps) {
        const isRunning = this.props.isRunning;
        if (prevProps.isRunning === isRunning) {
            return;
        }
        this.setState({ isRunning });
        if (isRunning) {
            this.startTimer();
        }
        else {
            this.stopTimer();
        }
    }
    componentWillUnmount() {
        this.stopTimer();
    }
    componentDidMount() {
        this.stopTimer();
    }
    formatTime(totalSeconds) {
        const minutes = Math.floor(totalSeconds / 60);
        const secs = totalSeconds % 60;
        return `${String(minutes).padStart(2, '0')}:${String(secs).padStart(2, '0')}`;
    }
    startTimer() {
        this.intervalId = setInterval(this.updateTimer, 1000);
    }
    stopTimer() {
        if (this.intervalId) {
            clearInterval(this.intervalId);
            this.intervalId = null;
        }
    }
    render() {
        const { time } = this.state;
        return (React.createElement("div", { className: 'c-text c-text--book c-text--md c-text--primary u-text-bold u-text-center c-text-title' }, time));
    }
};
Timer = __decorate([
    AwesomeComponent({ api: TimerAPI, type: ComponentType.DATA_DISPLAY })
], Timer);
export default Timer;
//# sourceMappingURL=timer.js.map